var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_21769",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8.74228e-7,
    width: 20,
    height: 20,
    transform: "rotate(90 20 8.74228e-07)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_21769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97731 4.30588C7.44633 4.0538 7.93057 3.86338 8.43001 3.73463C8.9296 3.60588 9.43897 3.5415 9.95814 3.5415C11.7605 3.5415 13.2944 4.16866 14.5598 5.42296C15.8254 6.67727 16.4581 8.20289 16.4581 9.99984L16.4581 10.6505L17.9998 9.1088L18.8779 9.98692L15.8331 13.0319L12.7883 9.98692L13.6665 9.1088L15.2081 10.6505L15.2081 9.99984C15.2081 8.5522 14.6986 7.3222 13.6794 6.30984C12.6601 5.29762 11.4197 4.7915 9.95814 4.7915C9.613 4.7915 9.26821 4.82914 8.92376 4.90442C8.57918 4.97984 8.24286 5.09282 7.91481 5.24338L6.97731 4.30588ZM1.12168 10.0128L4.16647 6.96775L7.21126 10.0128L6.33314 10.8909L4.79147 9.34921L4.79147 9.99984C4.79147 11.4475 5.30105 12.6775 6.32022 13.6898C7.33953 14.7021 8.57994 15.2082 10.0415 15.2082C10.3866 15.2082 10.7314 15.1705 11.0758 15.0953C11.4204 15.0198 11.7567 14.9069 12.0848 14.7563L13.0223 15.6938C12.5533 15.9459 12.069 16.1363 11.5696 16.265C11.07 16.3938 10.5606 16.4582 10.0415 16.4582C8.23911 16.4582 6.70522 15.831 5.4398 14.5767C4.17425 13.3224 3.54147 11.7968 3.54147 9.99984L3.54147 9.34921L1.9998 10.8909L1.12168 10.0128Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerateIcon);
export default __webpack_public_path__ + "static/media/regenerate-icon.0abf2ad897ef84c9d88956933fbd096e.svg";
export { ForwardRef as ReactComponent };